export default __webpack_public_path__ + "static/media/Oliver_ParticleSmoke-34.617acdd7.png";